import { render, staticRenderFns } from "./ChatCallV2.vue?vue&type=template&id=2db15c3a&scoped=true"
import script from "./ChatCallV2.vue?vue&type=script&lang=js"
export * from "./ChatCallV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db15c3a",
  null
  
)

export default component.exports